// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"3c67f788","195":"0379b2e2","269":"245ff2b1","338":"701d2cce","378":"09cf859e","603":"9a41e615"}[chunkId] + ".chunk.js";
};